export default class BaseSyncManager {
  constructor() {
    this.csrfToken = $('meta[name="csrf-token"]').attr('content');
  }

  syncSingleEntity(modal) {
    const syncUrl = modal.data('sync-url');

    return $.ajax({
      url: syncUrl,
      method: 'POST',
      dataType: 'json',
      headers: {
        'X-CSRF-Token': this.csrfToken
      },
      contentType: 'application/json'
    });
  }

  checkMultipleEntities(entities, bulkCheckUrl) {
    return $.ajax({
      url: bulkCheckUrl,
      method: 'POST',
      dataType: 'json',
      headers: {
        'X-CSRF-Token': this.csrfToken
      },
      data: JSON.stringify({
        entities: entities.map(entity => ({
          id: entity.id,
          name: entity.name
        }))
      }),
      contentType: 'application/json'
    });
  }

  syncMultipleEntities(entityIds, bulkSyncUrl) {
    return $.ajax({
      url: bulkSyncUrl,
      method: 'POST',
      dataType: 'json',
      headers: {
        'X-CSRF-Token': this.csrfToken
      },
      data: JSON.stringify({
        entity_ids: entityIds
      }),
      contentType: 'application/json'
    });
  }
}